import React from 'react';

import './ValidationError.scss';

const ValidationError = ({ errorMessage }) => {
  return <div className="validation-error">{errorMessage}</div>;
};

export default ValidationError;